import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50 flex flex-col items-center justify-center px-4">
      <div className="text-center">
        <h1 className="text-8xl md:text-[10rem] font-black font-heading text-background-200 select-none">
          404
        </h1>
        <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900 mt-4 mb-2">
          页面未找到
        </h2>
        <p className="text-sm text-foreground-500 mb-8 max-w-md mx-auto leading-relaxed">
          很抱歉，您访问的页面不存在或已被移除。请检查网址是否正确，或返回首页继续浏览。
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3 rounded-full font-semibold text-sm whitespace-nowrap transition-all duration-300 no-underline cursor-pointer"
        >
          <i className="ri-home-4-line"></i> 返回首页
        </Link>
      </div>
    </div>
  );
}